import React from "react";
import "./Meanings.css";

export default function Meanings(props) {
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  if (props.data.example) {
    return (
      <div className="def px-3 mb-1">
        <h4>{capitalize(props.data.partOfSpeech)}</h4>
        <div className="definition">{capitalize(props.data.definition)}</div>
        <div className="d-flex align-items-baseline Examples">
          <h6>Example : </h6> <p>{capitalize(props.data.example)}</p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="def px-3 mb-1">
        <h4>{capitalize(props.data.partOfSpeech)}</h4>
        <div className="definition">{capitalize(props.data.definition)}</div>
      </div>
    );
  }
}
